import React from 'react';
import { Singleton } from '../../../js/Singleton';
import { inboundCall, outBoundCall, framesCamp } from '../../../Images/Images';

const HeaderAssisted = ({campaignName,iconCallFrame,callKey}) => {
    let language = new Singleton();
    return (
        
            <div className='callWindowHeaderAssisted'>
                    <div className="campaingAssistedIcon">
                        <img className='iconCallImageA' src={outBoundCall} alt='icon' />
                        <img className='iconCallImageA iconPaddingA' src={iconCallFrame > 0 ? framesCamp[iconCallFrame] : ''} alt='iconCallImage' />
                    </div>
                    
                    <div className="Info">
                        <div className="campaingAssistedNameA">
                            <p className='campaignNameA'>{campaignName}</p>
                        </div>
                        <div className='callKeyA'>
                             <p className='callKeyTitleA'>{language.getText('GUICallSpacecallkey')}</p>
                             <div className='callKeyBodyA'>{callKey}</div>
                         </div> 
                    </div>            
            </div>            
        
    )
}
export default HeaderAssisted;


// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/HeaderAssisted.jsx